



























import Vue from 'vue';
import CitySelectionForm from '@/components/forms/CitySelectionForm.vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BackButton from '@/components/BackButton.vue';
import pipeline from '@/pipeline';
import { City } from '@/store/modules/location/state';
import Analytics from '@/helpers/analytics';
import { Toast } from '@/components/ds';
import { AnalyticsActions } from '@/store/modules/analytics/actions';

export default Vue.extend({
  components: {
    CitySelectionForm,
    PipelineMenuWrapper,
    BackButton,
    Toast,
  },
  data() {
    return {
      error: false,
    };
  },
  computed: {
    availableCities(): City[] {
      return this.$store.getters.availableCities || [];
    },
    selectedCity(): string {
      const { city, state } = this.$store.getters.selectedCity || {};
      return city && state ? `${city}, ${state}` : '';
    },
  },
  created() {
    this.$store.dispatch('PULL_AVAILABLE_CITIES');
  },
  methods: {
    async selectedHandler(city: City) {
      await this.$store.dispatch('UPDATE_CITY', { city }).catch(error => this.errorHandler(error));

      this.$store.dispatch(AnalyticsActions.CITY_CHOSEN, {
        grad_primeira_opcao_cidade: this.selectedCity,
        city: this.selectedCity,
      });
      Analytics.trackGTM({
        event: 'city_selected',
        grad_selected_city: this.selectedCity,
        processo_seletivo_id: this.$store.getters.admissionId,
      });

      pipeline.next();
    },
    errorHandler(error: any) {
      this.error = true;
      setTimeout(() => {
        this.error = false;
      }, 5000);
      throw error;
    },
  },
});
